"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../helpers/index.js");
var _index2 = require("../../utils/index.js");
var stringField = _index.formatters.stringField;
var getDefaultTemplate = function getDefaultTemplate(_ref) {
  var term = _ref.term,
    numberOfResults = _ref.numberOfResults;
  var common = {
    _telus: {
      instances: {
        value: 1
      },
      term: stringField(term),
      numberOfResults: numberOfResults
    }
  };
  var resultFields = numberOfResults ? {
    _telus: {
      successInstances: {
        value: 1
      },
      nullInstances: {
        value: 0
      }
    }
  } : {
    _telus: {
      successInstances: {
        value: 0
      },
      nullInstances: {
        value: 1
      }
    }
  };
  return (0, _index2.mergeObjects)(resultFields, common);
};
var _default = exports["default"] = getDefaultTemplate;